module.exports = __webpack_public_path__ + "static/media/Farm.9c631e0b.svg";